export const watchFaqs = [
  {
    question: "ساعت چگونه کودکان را به تحرک تشویق می‌کند؟",
    answer: "با نوتیفیکیشن‌های دوستانه، یادآوری بلند شدن و برداشتن ۵۰۰ قدم می‌کند تا به هدف روزانه برسند؛ ایده‌آل برای ظهرهای نشسته در کلاس. این ویژگی بازی‌وار، عادت‌های سالم را بدون اجبار ایجاد می‌کند."
  },
  {
    question: "چگونه ساعت هشدار خروج کودک از محدوده امن را می‌دهد؟",
    answer: "ساعت با GPS دقیق، وقتی کودک از محدوده تعریف‌شده (مانند خانه یا مدرسه) خارج شود، نوتیفیکیشن فوری با نقشه به والدین ارسال می‌کند. این ویژگی آرامش خاطر والدین را در ساعاتی مانند صبح‌ها تضمین می‌کند."
  },
  {
    question: "ساعت‌های کودک دلبند چه گواهی ضدآبی دارند؟",
    answer: "مدل‌های KidWatch 3، 4 و 5 با IP67 در برابر آب و گردوغبار مقاوم هستند، که برای بازی‌های کودکان در محیط‌های مرطوب یا خاکی ایمن است. مدل‌های 1 و 2 با IPX6/IPX7 فقط برای پاشش آب مناسب‌اند."
  },
  {
    question: "تماس اضطراری در ساعت برای کودکان چگونه است؟",
    answer: "با نگه داشتن دکمه SOS، ساعت فوراً با اورژانس و نزدیک‌ترین خانواده تماس می‌گیرد و موقعیت را ارسال می‌کند؛ مناسب برای فعالیت‌هایی مانند دوچرخه‌سواری عصرگاهی. این ویژگی ساده، امنیت کودکان فعال را افزایش می‌دهد."
  },
  {
    question: "آیا ساعت‌ها GPS دارند؟",
    answer: "بله، همه مدل‌ها GPS دقیق برای ردیابی موقعیت کودکان دارند، که والدین را در نظارت لحظه‌ای یاری می‌رساند. این ویژگی در تمام KidWatchها استاندارد است و بدون نیاز به اپ اضافی کار می‌کند."
  },
  {
    question: "یادآور کلاس‌ها با لرزش در ساعت چطور کار می‌کند؟",
    answer: "۱۰ دقیقه قبل از کلاس (مانند زبان)، با لرزش ظریف و باز کردن اسلایدهای درس روی گوشی هشدار می‌دهد. این ابزار، تمرکز کودکان را بدون حواس‌پرتی افزایش می‌دهد و زمان‌بندی را آسان می‌کند."
  }
];